import * as React from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { useEditorState } from '../BaseEditor/hooks/useBaseEditorFormatState';
import './ContentEditable.css';

type Props = {
  className?: string;
  placeholderClassName?: string;
  placeholder: any;
};

export default function LexicalContentEditable({ className, placeholder }: Props): JSX.Element {
  const [editor] = useLexicalComposerContext();
  const { isEditable } = useEditorState(editor as any);

  return (
    <div className={`${!isEditable ? 'max-w-[868px] mx-auto' : 'max-w-full'}`}>
      <ContentEditable
        className={
          className ?? 'ContentEditable__root min-h-[70vh] md:min-h-[87vh] mb-[190px] md:mb-[80px]'
        }
        aria-placeholder={placeholder}
        placeholder={placeholder}
      />
    </div>
  );
}
